import { useResponsiveTierContext, type ResponsiveTierValue } from '@renderer/context/ResponsiveTierContext'
import { useDeviceOrientation } from '@renderer/hooks/useDeviceOrientation'
import { computeRawTier, tierIsCompact, tierIsTiny } from '@renderer/utils/responsiveTier'

/**
 * Unified responsive tier for session UI. Under `ResponsiveTierProvider` (View), uses
 * stabilized tiers; elsewhere falls back to raw viewport tiers (no hysteresis).
 */
export function useResponsiveTier(): ResponsiveTierValue {
  const ctx = useResponsiveTierContext()
  const device = useDeviceOrientation()

  if (ctx) {
    return ctx
  }

  const short = Math.min(device.viewportWidth, device.viewportHeight)
  const long = Math.max(device.viewportWidth, device.viewportHeight)
  const tier = computeRawTier(short, long)
  return {
    tier,
    isCompact: tierIsCompact(tier),
    isTiny: tierIsTiny(tier),
    isPortraitViewport: device.isPortrait,
    isLandscapeViewport: device.isLandscape,
    viewportWidth: device.viewportWidth,
    viewportHeight: device.viewportHeight
  }
}

export type { ResponsiveTierValue }
